import { type LocationsQueryParams } from 'services/locations';
import { LocationsSearch } from '../hooks/use-locations';

type getQueryParamsProps = LocationsQueryParams & {
  searchValue: LocationsSearch;
  showStoresOutsideOfCountry: boolean;
};
export const getQueryParams = ({
  searchValue,
  showStoresOutsideOfCountry,
  storeId,
  locale
}: getQueryParamsProps) => {
  const queryParams: LocationsQueryParams = {
    extendedList: showStoresOutsideOfCountry,
    storeId,
    locale
  };

  if (typeof searchValue === 'string') {
    queryParams['search'] = searchValue;
  } else {
    queryParams['latitude'] = searchValue.lat;
    queryParams['longitude'] = searchValue.lng;
  }

  return queryParams;
};
